import * as mapboxgl from 'mapbox-gl'

export type Viewport =
  | {
      type: 'bounds'
      bounds: mapboxgl.LngLatBounds
      options: mapboxgl.FitBoundsOptions
    }
  | {
      type: 'center'
      options: mapboxgl.FlyToOptions
    }

export function getViewport(coordinates: mapboxgl.LngLatLike[]): Viewport | undefined {
  const uniqueCoordinatesDict: Record<string, mapboxgl.LngLat> = {}
  for (const coord of coordinates) {
    const lngLat = mapboxgl.LngLat.convert(coord)
    const hash = `${lngLat.lat}:${lngLat.lng}`
    uniqueCoordinatesDict[hash] = lngLat
  }

  const uniqueCoordinates = Object.values(uniqueCoordinatesDict)

  if (uniqueCoordinates.length > 1) {
    const bounds = new mapboxgl.LngLatBounds()
    for (const coordinate of uniqueCoordinates) {
      bounds.extend(coordinate)
    }

    return {
      type: 'bounds',
      bounds,
      options: {
        padding: 60,
        duration: 0,
      },
    }
  } else if (uniqueCoordinates.length === 1) {
    return {
      type: 'center',
      options: {
        center: coordinates[0],
        zoom: 15,
        duration: 0,
      },
    }
  }
}
